export const GROUP_STAFF_ROLES = new Set(['admin', 'developer']);

export function isGroupStaffRole(role?: string | null): boolean {
  return !!role && GROUP_STAFF_ROLES.has(role);
}

export interface GroupMemberRow {
  user_id: number;
  reference_no: string;
  full_name?: string | null;
  photo_path?: string | null;
  role: string;
  group_role: string;
}

export function filterVisibleGroupMembers<T extends { role: string }>(members: T[]): T[] {
  return members.filter((m) => !isGroupStaffRole(m.role));
}

/** Official-answer picker: hide admin/developer unless they are the session creator. */
export function filterMembersForOfficialSource<T extends { user_id: number; role: string }>(
  members: T[],
  creatorUserId?: number | null
): T[] {
  return members.filter(
    (m) => !isGroupStaffRole(m.role) || (creatorUserId != null && m.user_id === creatorUserId)
  );
}

export function buildOfficialSourceMemberOptions<T extends {
  user_id: number;
  role: string;
  full_name?: string | null;
  reference_no: string;
}>(
  members: T[],
  creatorUserId?: number | null,
  labelFn?: (m: T) => string,
  currentUserId?: number | null
): Array<{ user_id: number; label: string }> {
  return filterMembersForOfficialSource(members, creatorUserId).map((m) => {
    if (currentUserId != null && Number(m.user_id) === Number(currentUserId)) {
      return { user_id: m.user_id, label: '您' };
    }
    return {
      user_id: m.user_id,
      label: labelFn ? labelFn(m) : m.full_name?.trim() || m.reference_no,
    };
  });
}
